export default __webpack_public_path__ + "static/media/burger-icon.e4bf7bec.svg";